module.exports = __webpack_public_path__ + "static/media/ic_chat.50342ff9.png";